export const POSITIONS_FEES_REFRESH_KEY = "POSITIONS_FEES_REFRESH_KEY";

export const LIQUIDITY_YOUR_POSITIONS_REFRESH_KEY = "YOUR_POSITIONS_REFRESH_KEY";

export const LIQUIDITY_OWNER_REFRESH_KEY = "LIQUIDITY_OWNER_REFRESH_KEY";
